import { Typography, useTheme } from '@mui/material';
import { convertConstStringToText } from '@ui-framework/index';
import IconLibrary from './IconLibrary';

export const claimStatusConfig = theme => ({
  INCOMPLETE: {
    label: 'Incomplete',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: IconLibrary.CLAIM_STATUS_INCOMPLETE,
    iconColor: 'warning',
  },
  CANCELED: {
    label: 'Canceled',
    borderColor: theme.palette.error.dark,
    textColor: 'error',
    Icon: IconLibrary.CLAIM_STATUS_CANCELED,
    iconColor: 'error',
  },
  PENDING_ADMINISTRATOR_REVIEW: {
    label: 'Pending Administrator Review',
    borderColor: theme.palette.info.dark,
    textColor: 'info',
    Icon: IconLibrary.CLAIM_STATUS_PENDING_ADMIN_REVIEW,
    iconColor: 'info',
  },
  PENDING_UNDERWRITER_REVIEW: {
    label: 'Pending Underwriter Review',
    borderColor: theme.palette.info.dark,
    textColor: 'info',
    Icon: IconLibrary.CLAIM_STATUS_PENDING_UNDERWRITER_REVIEW,
    iconColor: 'info',
  },
  PENDING_UNDERWRITER_RECEIPT: {
    label: 'Pending Underwriter Receipt',
    borderColor: theme.palette.info.dark,
    textColor: 'info',
    Icon: IconLibrary.CLAIM_STATUS_PENDING_UNDERWRITER_RECEIPT,
    iconColor: 'info',
  },
  APPROVED: {
    label: 'Approved',
    borderColor: theme.palette.success.dark,
    textColor: 'success',
    Icon: IconLibrary.CLAIM_STATUS_APPROVED,
    iconColor: 'success',
  },
  APPROVED_OVERRIDE: {
    label: 'Approved Override',
    borderColor: theme.palette.success.dark,
    textColor: 'success',
    Icon: IconLibrary.CLAIM_STATUS_APPROVED_OVERRIDE,
    iconColor: 'success',
  },
  REJECTED: {
    label: 'Rejected',
    borderColor: theme.palette.error.dark,
    textColor: 'error',
    Icon: IconLibrary.CLAIM_STATUS_REJECTED,
    iconColor: 'error',
  },
  REJECTED_OVERRIDE: {
    label: 'Rejected Override',
    borderColor: theme.palette.error.dark,
    textColor: 'error',
    Icon: IconLibrary.CLAIM_STATUS_REJECTED_OVERRIDE,
    iconColor: 'error',
  },
  CORRECTED: {
    label: 'Corrected',
    borderColor: theme.palette.warning.dark,
    textColor: 'warning',
    Icon: IconLibrary.CLAIM_STATUS_CORRECTED,
    iconColor: 'warning',
  },
  CORRECTION_DRAFT: {
    label: 'Correction Draft',
    borderColor: theme.palette.warning.dark,
    textColor: 'warning',
    Icon: IconLibrary.CLAIM_STATUS_CORRECTION_DRAFT,
    iconColor: 'warning',
  },
  TRANSFERRED: {
    label: 'Transferred',
    borderColor: theme.palette.mutedBorder,
    textColor: 'info',
    Icon: IconLibrary.CLAIM_STATUS_TRANSFERRED,
    iconColor: 'secondary',
  },
  PAID: {
    label: 'Paid',
    borderColor: theme.palette.success.dark,
    textColor: 'success',
    Icon: IconLibrary.CLAIM_STATUS_PAID,
    iconColor: 'success',
  },
});

function ClaimStatus({ children: status, withIcon = false, component = 'p' }) {
  if (!(typeof status === 'string')) return status;

  const theme = useTheme();
  const config = claimStatusConfig(theme);

  if (config?.[status]) {
    const { Icon, label, textColor, iconColor } = config[status];
    return (
      <Typography
        component={component}
        color={textColor}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: theme.palette[textColor]?.main,
        }}>
        {withIcon && Icon && <Icon color={iconColor} fontSize="small" />}
        {label}
      </Typography>
    );
  }

  return (
    <Typography color="inherit" component={component}>
      {convertConstStringToText(status)}
    </Typography>
  );
}

export default ClaimStatus;
